import React from "react";
import { Link } from "gatsby";
import { Location } from "@reach/router";
import locales from "../../i18n/locales";
import { useActiveLanguageCode } from "../../i18n/LanguageProvider";

const LanguageSelector = () => {
  const toPage = pathname => pathname.split(/\/[a-z]{2}\//).pop();
  const locale = useActiveLanguageCode();

  return (
    <Location>
      {({ location: { pathname } }) => (
        <div className="navbar-item has-dropdown is-hoverable">
          <a className="navbar-link">{locales[locale].locale}</a>

          <div className="navbar-dropdown">
            {Object.keys(locales).map(key => (
              <Link
                key={locales[key].locale}
                className={`navbar-item${key === locale ? " is-active" : ""}`}
                to={
                  locales[key].default
                    ? `/${toPage(pathname)}`
                    : `/${locales[key].path}/${toPage(pathname)}`
                }
              >
                {locales[key].locale}
              </Link>
            ))}
          </div>
        </div>
      )}
    </Location>
  );
};

export default LanguageSelector;
